/**
 * Apresentação de banners: play/pause de vídeos por slide visível e breakpoint.
 */
function isDesktopViewport() {
  return window.matchMedia('(min-width: 750px)').matches;
}

/**
 * @param {HTMLElement} slide
 */
function syncSlideVideos(slide) {
  const slideHidden = slide.getAttribute('aria-hidden') === 'true';
  const desktop = isDesktopViewport();

  slide.querySelectorAll('video.jv-bp__video').forEach((video) => {
    const isMobileOnly = video.classList.contains('jv-bp__video--mobile');
    const isDesktopOnly = video.classList.contains('jv-bp__video--desktop');
    const wrongBreakpoint =
      (isMobileOnly && desktop) || (isDesktopOnly && !desktop);

    if (slideHidden || wrongBreakpoint) {
      if (!video.paused) video.pause();
      return;
    }

    if (video.paused) {
      video.play().catch(() => {});
    }
  });
}

/**
 * @param {ParentNode} [root]
 */
function initJvBpVideos(root = document) {
  root.querySelectorAll('.jv-bp').forEach((sectionRoot) => {
    if (sectionRoot.dataset.jvBpVideoReady === 'true') return;
    sectionRoot.dataset.jvBpVideoReady = 'true';

    const slides = sectionRoot.querySelectorAll('slideshow-slide');
    if (slides.length === 0) return;

    slides.forEach((slide) => {
      syncSlideVideos(slide);
      const observer = new MutationObserver(() => syncSlideVideos(slide));
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });

    const mq = window.matchMedia('(min-width: 750px)');
    const onBreakpoint = () => {
      slides.forEach((slide) => syncSlideVideos(slide));
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onBreakpoint);
    } else {
      mq.addListener(onBreakpoint);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initJvBpVideos(), { once: true });
} else {
  initJvBpVideos();
}

document.addEventListener('shopify:section:load', (event) => {
  initJvBpVideos(event.target instanceof Element ? event.target : document);
});
